/* IN A BOX — creator browser (marketplace + configurator picker) and Find My Creator. */
(function () {
  'use strict';
  var IAB = window.IAB;
  if (!IAB) return;

  var PAGE = 24;
  var GROUPS = [
    { key: 'gender', label: 'Gender', get: function (c) { return c.gender ? [c.gender] : []; } },
    { key: 'age', label: 'Age', get: function (c) { return c.age ? [ageBucket(c.age)] : []; }, order: ['18–24', '25–34', '35–44', '45+'] },
    { key: 'region', label: 'Appearance / region', get: function (c) { return c.region ? [c.region] : []; } },
    { key: 'language', label: 'Language', get: function (c) { return c.languages || []; } },
    { key: 'industry', label: 'Industry', get: function (c) { return c.industries || []; } },
    { key: 'style', label: 'Creator style', get: function (c) { return c.style ? [c.style] : []; } }
  ];
  function ageBucket(a) {
    var n = parseInt(String(a), 10);
    if (isNaN(n)) return a;
    if (n < 25) return '18–24'; if (n < 35) return '25–34'; if (n < 45) return '35–44'; return '45+';
  }
  var groupByKey = {}; GROUPS.forEach(function (g) { groupByKey[g.key] = g; });

  function Browser(root, opts) {
    this.root = root;
    this.opts = opts || {};
    this.mode = this.opts.mode || root.getAttribute('data-mode') || 'link';
    this.max = this.opts.max || 1;
    this.filters = {};           // key -> Set
    this.q = '';
    this.shown = PAGE;
    this.selected = [];
    this.all = [];
    this.el = function (s) { return root.querySelector('[data-b-' + s + ']'); };
    this.init();
  }

  Browser.prototype.init = function () {
    var self = this;
    var grid = this.el('grid');
    grid.innerHTML = new Array(9).join('<div class="iab-ccard"><div class="iab-ccard__img iab-skel"></div><div class="iab-ccard__body"><p class="iab-ccard__name">&nbsp;</p></div></div>');
    IAB.loadCreators().then(function (list) {
      if (self.mode === 'select') {
        var kind = self.opts.kind || 'ugc';
        list = list.filter(function (c) { return kind === 'influencer' ? c.influencer !== false : c.ugc !== false; });
      }
      self.all = list;
      self.buildFilters();
      self.readUrl();
      self.render();
      if (self.opts.onReady) self.opts.onReady(list);
    });

    var s = this.el('search');
    if (s) s.addEventListener('input', debounce(function () { self.q = s.value.trim().toLowerCase(); self.shown = PAGE; self.render(); }, 150));
    var more = this.el('more');
    if (more) more.addEventListener('click', function () { self.shown += PAGE; self.render(); });
    var root = this.root;
    root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-f]');
      if (chip && root.contains(chip)) { self.toggle(chip.getAttribute('data-f'), chip.getAttribute('data-v')); return; }
      var clear = e.target.closest('[data-b-clear]');
      if (clear) { self.filters = {}; self.q = ''; if (s) s.value = ''; self.shown = PAGE; self.syncChips(); self.render(); return; }
      var card = e.target.closest('button.iab-ccard[data-creator]');
      if (card && self.mode === 'select') self.pick(card.getAttribute('data-creator'));
    });
  };

  Browser.prototype.buildFilters = function () {
    var self = this;
    var counts = {};
    GROUPS.forEach(function (g) { counts[g.key] = {}; });
    this.all.forEach(function (c) {
      GROUPS.forEach(function (g) { g.get(c).forEach(function (v) { counts[g.key][v] = (counts[g.key][v] || 0) + 1; }); });
    });
    var box = this.el('groups');
    if (box) {
      box.innerHTML = GROUPS.map(function (g) {
        var vals = Object.keys(counts[g.key]);
        if (!vals.length) return '';
        if (g.order) vals.sort(function (a, b) { return g.order.indexOf(a) - g.order.indexOf(b); }); else vals.sort();
        return '<div class="iab-fgroup"><h4>' + IAB.esc(g.label) + '</h4><div class="iab-chips">' + vals.map(function (v) {
          return '<button type="button" class="iab-chip" aria-pressed="false" data-f="' + g.key + '" data-v="' + IAB.esc(v) + '">' + IAB.esc(v) + ' <span class="iab-muted" style="font-size:12px">' + counts[g.key][v] + '</span></button>';
        }).join('') + '</div></div>';
      }).join('');
    }
    var cats = this.el('cats');
    if (cats) {
      var inds = (cats.getAttribute('data-list') || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
      if (!inds.length) inds = Object.keys(counts.industry).sort();
      cats.innerHTML = '<button type="button" class="iab-chip is-on" data-f="industry" data-v="*">All</button>' + inds.map(function (v) {
        var n = counts.industry[v] || 0;
        return '<button type="button" class="iab-chip" aria-pressed="false" data-f="industry" data-v="' + IAB.esc(v) + '"' + (n ? '' : ' disabled title="No creators tagged yet"') + '>' + IAB.esc(v) + '</button>';
      }).join('');
    }
  };

  Browser.prototype.readUrl = function () {
    if (this.mode !== 'link') return;
    var p = new URLSearchParams(location.search);
    var self = this;
    GROUPS.forEach(function (g) { var v = p.get(g.key); if (v) self.filters[g.key] = new Set(v.split('|')); });
    if (p.get('q')) { this.q = p.get('q').toLowerCase(); var s = this.el('search'); if (s) s.value = p.get('q'); }
    this.syncChips();
  };
  Browser.prototype.writeUrl = function () {
    if (this.mode !== 'link' || !history.replaceState) return;
    var p = new URLSearchParams();
    var self = this;
    Object.keys(this.filters).forEach(function (k) { if (self.filters[k].size) p.set(k, Array.from(self.filters[k]).join('|')); });
    if (this.q) p.set('q', this.q);
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  };

  Browser.prototype.toggle = function (key, val) {
    if (val === '*') { delete this.filters[key]; }
    else {
      var set = this.filters[key] || (this.filters[key] = new Set());
      if (set.has(val)) set.delete(val); else set.add(val);
      if (!set.size) delete this.filters[key];
    }
    this.shown = PAGE;
    this.syncChips();
    this.render();
    IAB.track('creator_filter', { key: key, value: val });
  };
  Browser.prototype.setFilter = function (key, vals) {
    if (!vals || !vals.length) delete this.filters[key]; else this.filters[key] = new Set(vals);
    this.shown = PAGE; this.syncChips(); this.render();
  };

  Browser.prototype.syncChips = function () {
    var self = this, active = 0;
    Object.keys(this.filters).forEach(function (k) { active += self.filters[k].size; });
    this.root.querySelectorAll('[data-f]').forEach(function (ch) {
      var k = ch.getAttribute('data-f'), v = ch.getAttribute('data-v');
      var on = v === '*' ? !self.filters[k] : !!(self.filters[k] && self.filters[k].has(v));
      ch.classList.toggle('is-on', on);
      ch.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    this.root.querySelectorAll('[data-b-active]').forEach(function (b) { b.textContent = active; b.hidden = !active; });
  };

  Browser.prototype.match = function (c) {
    var self = this;
    for (var k in this.filters) {
      var vals = groupByKey[k].get(c), set = this.filters[k], hit = false;
      for (var i = 0; i < vals.length; i++) if (set.has(vals[i])) { hit = true; break; }
      if (!hit) return false;
    }
    if (this.q) {
      var hay = [c.name, c.id, c.region, c.style, c.gender].concat(c.languages || [], c.industries || []).join(' ').toLowerCase();
      if (hay.indexOf(this.q) === -1) return false;
    }
    return true;
  };

  Browser.prototype.render = function () {
    var self = this;
    var list = this.all.filter(function (c) { return self.match(c); });
    var grid = this.el('grid');
    var page = list.slice(0, this.shown);
    if (!list.length) {
      grid.innerHTML = '<div class="iab-empty" style="grid-column:1/-1"><p style="margin:0 0 12px"><b>No creators match those filters.</b></p><button type="button" class="iab-btn iab-btn--sm iab-btn--ghost" data-b-clear>Clear filters</button></div>';
    } else {
      grid.innerHTML = page.map(function (c) { return IAB.creatorCard(c, { select: self.mode === 'select' }); }).join('');
    }
    var cnt = this.el('count');
    if (cnt) cnt.textContent = list.length === this.all.length ? ('Showing ' + Math.min(this.shown, list.length) + ' of ' + this.all.length + ' AI creators') : (list.length + ' of ' + this.all.length + ' creators match');
    var more = this.el('more');
    if (more) more.hidden = list.length <= this.shown;
    this.markSelected();
    this.writeUrl();
    if (this.opts.onRender) this.opts.onRender(list);
  };

  Browser.prototype.byId = function (id) { for (var i = 0; i < this.all.length; i++) if (this.all[i].id === id) return this.all[i]; return null; };

  Browser.prototype.pick = function (id, silent) {
    var i = this.selected.indexOf(id);
    if (i > -1) this.selected.splice(i, 1);
    else if (this.max === 1) this.selected = [id];
    else if (this.selected.length < this.max) this.selected.push(id);
    else { IAB.toast('This package includes up to ' + this.max + ' creators. Deselect one first.'); return; }
    this.markSelected();
    if (!silent) {
      var c = this.byId(id);
      if (this.selected.indexOf(id) > -1 && c) IAB.track('avatar_selected', { creator_id: c.id, creator_name: c.name });
    }
    if (this.opts.onChange) this.opts.onChange(this.selected.map(this.byId, this).filter(Boolean));
  };
  Browser.prototype.setMax = function (n) {
    this.max = n;
    if (this.selected.length > n) this.selected = this.selected.slice(0, n);
    this.markSelected();
    if (this.opts.onChange) this.opts.onChange(this.selected.map(this.byId, this).filter(Boolean));
  };
  Browser.prototype.markSelected = function () {
    var sel = this.selected;
    this.root.querySelectorAll('button.iab-ccard[data-creator]').forEach(function (b) {
      var on = sel.indexOf(b.getAttribute('data-creator')) > -1;
      b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  /* ---------- Find My Creator ----------
     If a recommendation endpoint is configured (theme setting), POST {url, industry}
     and expect {creators:["AVA-001",...], note?:"..."}. With no endpoint there is NO
     fake analysis: we say matching isn't live yet and filter by the industry the
     customer tells us instead. */
  function Finder(root, browser, opts) {
    opts = opts || {};
    var endpoint = root.getAttribute('data-endpoint') || '';
    var form = root.querySelector('form');
    var msg = root.querySelector('[data-find-msg]');
    var recs = opts.recs || document.querySelector('[data-find-recs]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var url = (form.querySelector('[name=url]') || {}).value || '';
      var ind = (form.querySelector('[name=industry]') || {}).value || '';
      IAB.track('find_creator_submit', { has_endpoint: !!endpoint, industry: ind });
      if (!endpoint) {
        if (ind) {
          browser.setFilter('industry', [ind]);
          msg.innerHTML = 'AI matching isn\'t live yet, so we haven\'t analysed your page. For now we\'ve filtered the library to <b>' + IAB.esc(ind) + '</b> creators. Pick anyone who feels right.';
        } else {
          msg.innerHTML = 'AI matching isn\'t live yet. Choose your industry above and we\'ll filter the library for you, or browse everyone below.';
        }
        var tgt = root.parentNode.querySelector('[data-b-grid]') || document.querySelector('[data-b-grid]');
        if (ind && tgt) tgt.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      msg.innerHTML = '<span class="iab-spin"></span> Matching creators to your product…';
      fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ url: url, industry: ind }) })
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (d) {
          var list = (d.creators || []).map(function (id) { return browser.byId(id); }).filter(Boolean).slice(0, 5);
          if (!list.length) throw 0;
          msg.innerHTML = d.note ? IAB.esc(d.note) : 'Recommended for your brand:';
          if (recs) {
            recs.hidden = false;
            recs.querySelector('[data-find-grid]').innerHTML = list.map(function (c) { return IAB.creatorCard(c, { select: browser.mode === 'select' }); }).join('');
            browser.markSelected.call({ selected: browser.selected, root: recs });
          }
          IAB.track('find_creator_results', { count: list.length });
        })
        .catch(function () {
          msg.innerHTML = 'We couldn\'t match creators right now. Browse the library below, or filter by industry.';
          if (ind) browser.setFilter('industry', [ind]);
        });
    });
    if (recs) recs.addEventListener('click', function (e) {
      var card = e.target.closest('button.iab-ccard[data-creator]');
      if (card) { browser.pick(card.getAttribute('data-creator')); browser.markSelected.call({ selected: browser.selected, root: recs }); }
    });
  }

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  IAB.Browser = Browser;
  IAB.Finder = Finder;

  /* auto-init the marketplace page */
  document.addEventListener('DOMContentLoaded', function () {
    var m = document.querySelector('[data-iab-market]');
    if (!m) return;
    var b = new Browser(m, { mode: 'link' });
    var f = document.querySelector('[data-iab-find]');
    if (f) new Finder(f, b);
    var drawerApply = document.querySelector('[data-b-apply]');
    if (drawerApply) drawerApply.addEventListener('click', function () { var d = drawerApply.closest('.iab-drawer'); d.classList.remove('is-open'); document.body.style.overflow = ''; });
  });
})();
